import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import {
  RankingSection,
  FAQSection,
  ContactSection,
  AboutSection,
  CommentsSection,
  IndexSection,
} from './components/ContentSectionsPart1';
import {
  CardsSection,
  MediaSection,
  TopicsSection,
  UpdatesSection,
  AppSection,
  CarouselSection,
  FeaturesSection,
} from './components/ContentSectionsPart2';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <RankingSection />

        <FAQSection />

        <ContactSection />

        <AboutSection />

        <CommentsSection />

        <IndexSection />

        <CardsSection />

        <MediaSection />

        <TopicsSection />

        <UpdatesSection />

        <AppSection />

        <CarouselSection />

        <FeaturesSection />
      </main>

      <Footer />
    </div>
  );
}